import type { ReactNode } from "react";

// 답변 본문 마크다운 링크 공용 렌더러 (2026-11-02).
// LLM 이 실제 주소를 모르고 지어낸 상대 경로([출처](게시판/게시판/…/전산-설치파일))가
// 브라우저에서 isac.insunginfo.co.kr/게시판/… 로 해석돼 깨진 링크가 됐다.
// 절대 주소(http/https)·mailto 만 링크로 만들고, 그 외는 글자로만 보여 준다.
// 실제 참고문서는 시스템이 붙이는 SourceList 가 따로 표시하므로 손실이 없다.
export function isSafeHref(href?: string): href is string {
  return !!href && /^(https?:\/\/|mailto:)/i.test(href.trim());
}

export function SafeLink({ href, children }: { href?: string; children?: ReactNode }) {
  if (!isSafeHref(href)) return <span>{children}</span>;
  return (
    <a href={href} target="_blank" rel="noreferrer">
      {children}
    </a>
  );
}
